// Lo que ve cualquiera, con o sin sesión: catálogos, búsqueda y perfil público.
export const ORDENES_DE_BUSQUEDA = ['relevancia', 'primer_turno', 'puntaje', 'precio'];
